export const RoutesList = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  BLOCKED: '/blocked',
  HOME: '/home'
};
